import styled from 'styled-components';

export const Map = styled.div`
    flex: 1 0 0;
`;
